import React from 'react';
import styled from 'styled-components';

const SrcInfoContainer = styled.div`
  display: flex;
  background: transparent;
  margin: 25px 10px;

  .userInfoIcon {
    font-size: 50px;
    margin: 0px 15px 15px 15px;
  }
`;
const ActionContainer = styled.div`
  flex-grow: 2;
  display: flex;
  align-items: baseline;
  padding: 8px 0px 0px 20px;
`;

const SubPage = styled.div`
  background: var(--sops-lightpurple-to-black-bg);
  height: 100vh;
  padding: 0px !important;
`;

const ModalContent = styled.div`
  padding: 0;
  height: 100vh;
  width: calc(100vw - 60px);
  background: transparent;
  overflow-y: hidden;
`;

const BoxContainer = styled.div`
  height: auto;

  .Polaris-Card {
    border-radius: 0px !important;
    padding: 0px 0px;
    background: transparent !important;
    box-shadow: none;
    width: 100%;
    margin: 0px;
  }

  .Polaris-ResourceItem__Content {
    display: flex;
    align-items: center;
  }

  .Polaris-ResourceItem__Container {
    width: 100%;
  }

  .Polaris-ResourceItem {
    display: flex;
    align-items: center;

    .iconHolder {
      float: right;
      position: absolute;
      display: none;
      right: 0px;
    }
  }

  .Polaris-ResourceItem:hover {
    .iconHolder {
      display: block !important;
    }
  }

  .AddLink .Polaris-Link {
    position: relative;
    right: 0px;
    top: -26px;
    z-index: 999;
    left: 88%;
  }
`;

const RoleBoxContainer = styled(BoxContainer)`
  .Polaris-ResourceList {
    padding: 10px 0px;
    height: calc(100vh - 175px);
    overflow: auto;
  }
`;

const PageContent = styled.div`
  height: ${(props) => props.height || 'calc(100vh - 110px)'};
  display: flex;
  overflow: ${(props) => props.overflow || 'auto'};
`;

const ScrollContent = styled.div`
  height: ${(props) => props.height || 'calc(100vh - 90px)'};
  overflow: auto;
`;

const CardBox = styled.div`
  .Polaris-Card {
    width: 45%;
    margin: 9px;
    padding: 20px !important;
  }

  .Polaris-Card:last-child {
    margin-top: 8px !important;
  }
`;

const customSelectStyle = {
  menu: (provided, state) => ({
    ...provided
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: '1px dotted pink',
    color: state.isSelected ? 'red' : 'blue',
    padding: 20
  }),
  control: () => ({
    width: 200
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
};

const reactSelectErrorStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#fbeae5',
    borderColor: '#bf0711',
    // overwrittes hover style
    '&:hover': {
      borderColor: '#bf0711'
    }
  })
};

const colourStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: 999999
  }),
  control: (styles) => ({
    ...styles,
    zIndex: 9999,
    backgroundColor: 'white',
    border: 'none',
    borderRadius: 0,
    borderBottom: '1px solid #F4F5F7'
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? data.color
        : isFocused
        ? data.color
        : null,
      color: isDisabled
        ? '#ccc'
        : isSelected
        ? 0
          ? 'gray'
          : 'black'
        : data.color,
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active']
      }
    };
  },
  indicatorSeparator: (styles) => ({
    ...styles,
    backgroundColor: 'transparent'
  })
};

function HeaderTag(props) {
  return (
    <div className="flex header-tag mb10">
      <div className="CardHeader">{props.title}</div>
      <div className="header-triangle"></div>
    </div>
  );
}

const reactSelectInlineError = (error) => {
  return (
    <div className="Polaris-Labelled__Error">
      <div className="Polaris-InlineError flex-align-center">
        <div className="Polaris-InlineError__Icon">
          <span className="Polaris-Icon">
            <svg
              viewBox="0 0 20 20"
              className="Polaris-Icon__Svg"
              focusable="false"
              aria-hidden="true"
            >
              <path
                d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1-8h2V6H9v4zm0 4h2v-2H9v2z"
                fillRule="evenodd"
              ></path>
            </svg>
          </span>
        </div>
        {error}
      </div>
    </div>
  );
};

const InfoContainer = styled(SrcInfoContainer)`
  .Polaris-Heading {
    margin-bottom: 8px;
  }
`;

const NoDataWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: ${(props) => (props?.borderTop ? '1px solid #dedede' : 'none')};
`;

const BadgeWrapper = styled.div`
  font-size: 12px;
  padding: 4px 8px;
  color: rgba(0, 0, 0, 0.5);
  background-color: rgba(196, 196, 196, 0.2);
  height: 31px;
  margin-left: ${(props) => props?.marginLeft || '-44px'};
  z-index: 99;
  margin-top: ${(props) => props?.marginTop || '-6px'};
  display: flex;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-transform: uppercase;
`;

export {
  customSelectStyle,
  PageContent,
  ScrollContent,
  RoleBoxContainer,
  SrcInfoContainer,
  ActionContainer,
  SubPage,
  ModalContent,
  colourStyles,
  BoxContainer,
  HeaderTag,
  CardBox,
  reactSelectErrorStyles,
  reactSelectInlineError,
  InfoContainer,
  NoDataWrapper,
  BadgeWrapper
};
